import { findPersona, PERIOD } from "./data.js";
import { validDay, addDays, parseDay, anniversary, ageAt } from "../model.js";
export function mapBounds(id) {
  const p = findPersona(id);
  const horizon = Math.max(
    p.journal.profile.horizon,
    ageAt(p.birthDate, PERIOD.to) + 5,
  );
  return {
    from: p.birthDate,
    to: addDays(anniversary(p.birthDate, horizon), -1),
    horizon,
  };
}
export const views = ["calendar", "remember", "compass"];
export function initialView(id) {
  if (!findPersona(id)) throw new Error("Unknown public example");
  return {
    id,
    view: "calendar",
    date: "2026-08-24",
    scale: "life",
    query: "",
    where: "",
    page: 1,
    dailyPage: 1,
  };
}
// Only presentation transitions exist. No journal mutation, account identifier or persistence event.
export function transition(state, event) {
  const next = { ...state };
  const bounds = mapBounds(state.id);
  switch (event.type) {
    case "view":
      if (!views.includes(event.value)) return state;
      next.view = event.value;
      next.page = 1;
      break;
    case "scale":
      if (!["life", "year", "month", "week", "day"].includes(event.value))
        return state;
      next.scale = event.value;
      break;
    case "week":
    case "day":
      if (
        !validDay(event.value) ||
        event.value < bounds.from ||
        event.value > bounds.to
      )
        return state;
      next.date = event.value;
      next.scale = event.type === "week" ? "week" : next.scale;
      next.dailyPage = 1;
      break;
    case "move": {
      if (![1, -1].includes(event.value)) return state;
      if (state.scale === "life") return state;
      let date;
      if (state.scale === "year")
        date = `${Number(state.date.slice(0, 4)) + event.value}-01-01`;
      else if (state.scale === "month") {
        const d = parseDay(state.date);
        d.setDate(1);
        d.setMonth(d.getMonth() + event.value);
        date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
      } else
        date = addDays(
          state.date,
          event.value * (state.scale === "week" ? 7 : 1),
        );
      if (
        state.scale === "year" &&
        date.slice(0, 4) === bounds.from.slice(0, 4) &&
        date < bounds.from
      )
        date = bounds.from;
      if (
        state.scale === "month" &&
        date.slice(0, 7) === bounds.from.slice(0, 7) &&
        date < bounds.from
      )
        date = bounds.from;
      if (date < bounds.from || date > bounds.to) return state;
      next.date = date;
      next.dailyPage = 1;
      break;
    }
    case "search":
      next.query = String(event.query || "").slice(0, 200);
      next.where = ["", findPersona(state.id).place].includes(event.where)
        ? event.where
        : "";
      next.page = 1;
      break;
    case "page":
    case "dailyPage":
      if (
        !Number.isSafeInteger(event.value) ||
        event.value < 1 ||
        event.value > 100
      )
        return state;
      next[event.type] = event.value;
      break;
    default:
      return state;
  }
  return next;
}
export function fromHash(id, hash) {
  let state = initialView(id);
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  for (const type of ["view", "scale", "day"])
    state = transition(state, { type, value: params.get(type) });
  return state;
}
export const viewHash = (state) =>
  `#${new URLSearchParams({ view: state.view, scale: state.scale, day: state.date })}`;
